import { Automation } from './automation.model';

export class Automations {
  totalAutomations: number;
  totalUnreadAutomations: number;
  automation: Automation[];
}
